import * as api from '@owl-nest/api-client/next'

export function sortSubscriptionsByPrice(
  subscriptions: api.Reward[] | null | undefined,
  {
    prioritizeFeatured = false,
    activeMembershipId,
  }: { prioritizeFeatured?: boolean; activeMembershipId?: number } = {},
) {
  if (!subscriptions) {
    return []
  }

  const sortedSubscriptions = subscriptions.filter((subscription) => !subscription.is_hidden)

  if (!sortedSubscriptions || sortedSubscriptions.length === 0) {
    return []
  }

  const sortResult = [...sortedSubscriptions].sort((a, b) => {
    if (activeMembershipId === a.id && activeMembershipId !== b.id) {
      return -1
    }
    if (activeMembershipId !== a.id && activeMembershipId === b.id) {
      return 1
    }

    if (prioritizeFeatured) {
      if (a.is_featured && !b.is_featured) {
        return -1
      }
      if (!a.is_featured && b.is_featured) {
        return 1
      }
    }

    if (a.is_free && !b.is_free) {
      return 1
    }
    if (!a.is_free && b.is_free) {
      return -1
    }

    if ((a.price ?? 0) < (b.price ?? 0)) {
      return -1
    }
    if ((a.price ?? 0) > (b.price ?? 0)) {
      return 1
    }

    return 0
  })

  return sortResult
}
